import { IBusinessPremisesHttpParams } from '@core/interfaces/api.interface';
import {
	AllowedDetailsTabEnum,
	ProductEnum
}                                      from '@core/interfaces/common.interfaces';
import {
	RouteBaseDefinition,
	RouteBasePath
}                                      from '@core/interfaces/route.interface';
import { EntityVariantEnum }           from '@models/entity.model';

export enum BusinessPremisesRoutesEnum {
	ListPage = '',
	ListPageBulkTaxationReporting = 'bulk-taxation-reporting',
	DetailPage = ':businessPremisesId',
	UsagePage = ':businessPremisesId/usage/:product/:usagePeriod',
	DetailPageProduct = ':businessPremisesId/:product',
	DetailPageProductTab = ':businessPremisesId/:product/:tab',
	DetailPageProductTabVariant = ':businessPremisesId/:product/:tab/:variant',
	DetailPageErsFormPageCreate = ':businessPremisesId/:product/ers/create',
	DetailPageErsFormPageUpdate = ':businessPremisesId/:product/ers/:ersId/update',
	DetailPageErsExternalFormPageCreate = ':businessPremisesId/:product/ers/external/create',
	DetailPageErsExternalFormPageUpdate = ':businessPremisesId/:product/ers/external/:ersId/update',
	DetailPageTssExternalFormPageCreate = ':businessPremisesId/:product/tss/external/create',
	FormPageCreate = 'create',
	FormPageUpdate = ':businessPremisesId/update',
}


export interface BusinessPremisesListPageRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.BusinessPremises;
	path: BusinessPremsiesListPageRouteType;
	queryParams?: IBusinessPremisesHttpParams;
}

export interface BusinessPremisesDetailPageRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.BusinessPremises;
	path: BusinessPremisesRoutesEnum.DetailPage;
	params: { businessPremisesId: string };
}

export interface BusinessPremisesUsagePageRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.BusinessPremises;
	path: BusinessPremisesRoutesEnum.UsagePage;
	params: {
		product: ProductEnum,
		businessPremisesId: string,
		usagePeriod: string
	};
}

export interface BusinessPremisesDetailPageProductTabRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.BusinessPremises;
	path: BusinessPremisesRoutesEnum.DetailPageProductTab;
	params: {
		businessPremisesId: string;
		product: ProductEnum;
		tab: AllowedDetailsTabEnum;
	};
	replaceLastStoredRouteWithNew: boolean;
}


export interface BusinessPremisesDetailPageProductTabVariantRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.BusinessPremises;
	path: BusinessPremisesRoutesEnum.DetailPageProductTabVariant;
	params: {
		businessPremisesId: string;
		product: ProductEnum;
		tab: AllowedDetailsTabEnum;
		variant: EntityVariantEnum;
	};
	replaceLastStoredRouteWithNew: boolean;
}

export interface BusinessPremisesFormPageCreateRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.BusinessPremises;
	path: BusinessPremisesRoutesEnum.FormPageCreate;
}

export interface BusinessPremisesFormPageUpdateRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.BusinessPremises;
	path: BusinessPremisesRoutesEnum.FormPageUpdate;
	params: { businessPremisesId: string };
}

// ERS
// create
export interface BusinessPremisesDetailPageErsFormPageCreateBaseRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.BusinessPremises;
	params: {
		businessPremisesId: string,
		product: ProductEnum.FISCAL
	};
}

export interface BusinessPremisesDetailPageErsFormPageCreateRoute extends BusinessPremisesDetailPageErsFormPageCreateBaseRoute {
	path: BusinessPremisesRoutesEnum.DetailPageErsFormPageCreate;
}

export interface BusinessPremisesDetailPageErsExternalFormPageCreateRoute extends BusinessPremisesDetailPageErsFormPageCreateBaseRoute {
	path: BusinessPremisesRoutesEnum.DetailPageErsExternalFormPageCreate;
}

// update
export interface BusinessPremisesDetailPageErsFormPageUpdateBaseRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.BusinessPremises;
	params: {
		businessPremisesId: string,
		ersId: string,
		product: ProductEnum.FISCAL
	};
}

export interface BusinessPremisesDetailPageErsFormPageUpdateRoute extends BusinessPremisesDetailPageErsFormPageUpdateBaseRoute {
	path: BusinessPremisesRoutesEnum.DetailPageErsFormPageUpdate;
}

export interface BusinessPremisesDetailPageErsExternalFormPageUpdateRoute extends BusinessPremisesDetailPageErsFormPageCreateBaseRoute {
	path: BusinessPremisesRoutesEnum.DetailPageErsExternalFormPageUpdate;
}

// Tss
// create
export interface BusinessPremisesDetailPageTssFormPageCreateBaseRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.BusinessPremises;
	params: {
		businessPremisesId: string,
		product: ProductEnum.FISCAL
	};
}

export interface BusinessPremisesDetailPageTssExternalFormPageCreateRoute extends BusinessPremisesDetailPageTssFormPageCreateBaseRoute {
	path: BusinessPremisesRoutesEnum.DetailPageTssExternalFormPageCreate;
}


// types
export type BusinessPremsiesListPageRouteType =
	BusinessPremisesRoutesEnum.ListPage |
	BusinessPremisesRoutesEnum.ListPageBulkTaxationReporting;
